import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronDoubleLeft"><Path d="M9.99977 8L7.06043 10.9393C6.47465 11.5251 6.47465 12.4749 7.06043 13.0607L9.99977 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M16.9998 8L14.0604 10.9393C13.4746 11.5251 13.4746 12.4749 14.0604 13.0607L16.9998 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronDoubleLeft;
